export const theme = {
  textColor: '#cbd5e1', // Tailwind's slate-300
  fontSize: 12,
  axis: {
    domain: {
      line: {
        stroke: '#475569', // Tailwind's slate-600
        strokeWidth: 1,
      },
    },
    ticks: {
      line: {
        stroke: '#475569', // Tailwind's slate-600
        strokeWidth: 1,
      },
      text: {
        fontSize: 12,
        fill: '#CBD5E1', // Tailwind's slate-300
        // textAnchor: 'start',
      },
    },
    legend: {
      text: {
        fontSize: 12,
        fill: '#cbd5e1', // Tailwind's slate-300
      },
    },
  },
  grid: {
    line: {
      stroke: '#334155', // Tailwind's slate-700
      strokeWidth: 1,
    },
  },
  legends: {
    text: {
      fontSize: 12,
      fill: '#cbd5e1', // Tailwind's slate-300
    },
  },
  tooltip: {
    container: {
      background: '#1e293b', // Tailwind's slate-800
      color: '#cbd5e1', // Tailwind's slate-300
      fontSize: 12,
    },
  },
  tokens: {
    indigo: {
      50: '#eef2ff',
      100: '#e0e7ff',
      200: '#c7d2fe',
      300: '#a5b4fc',
      400: '#818cf8',
      500: '#6366f1',
      600: '#4f46e5',
      700: '#4338ca',
      800: '#3730a3',
      900: '#312e81',
    },
    violet: {
      50: '#f5f3ff',
      100: '#ede9fe',
      200: '#ddd6fe',
      300: '#c4b5fd',
      400: '#a78bfa',
      500: '#8b5cf6',
      600: '#7c3aed',
      700: '#6d28d9',
      800: '#5b21b6',
      900: '#4c1d95',
    },
    purple: {
      50: '#faf5ff',
      100: '#f3e8ff',
      200: '#e9d5ff',
      300: '#d8b4fe',
      400: '#c084fc',
      500: '#a855f7',
      600: '#9333ea',
      700: '#7e22ce',
      800: '#6b21a8',
      900: '#581c87',
    },
    fuchsia: {
      50: '#fdf4ff',
      100: '#fae8ff',
      200: '#f5d0fe',
      300: '#f0abfc',
      400: '#e879f9',
      500: '#d946ef',
      600: '#c026d3',
      700: '#a21caf',
      800: '#86198f',
      900: '#701a75',
    },
    emerald: {
      50: '#ecfdf5',
      100: '#d1fae5',
      200: '#a7f3d0',
      300: '#6ee7b7',
      400: '#34d399',
      500: '#10b981',
      600: '#059669',
      700: '#047857',
      800: '#065f46',
      900: '#064e3b',
    },
    red: {
      50: '#fef2f2',
      100: '#fee2e2',
      200: '#fecaca',
      300: '#fca5a5',
      400: '#f87171',
      500: '#ef4444',
      600: '#dc2626',
      700: '#b91c1c',
      800: '#991b1b',
      900: '#7f1d1d',
    },
    orange: {
      50: '#fff7ed',
      100: '#ffedd5',
      200: '#fed7aa',
      300: '#fdba74',
      400: '#fb923c',
      500: '#f97316',
      600: '#ea580c',
      700: '#c2410c',
      800: '#9a3412',
      900: '#7c2d12',
    },
    yellow: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
    },
  },
};